<template>
  <v-tooltip
    top
    :disabled="!tooltipMessage"
  >
    <template v-slot:activator="{ on }">
      <v-icon
        class="icon"
        :class="{ border, rounded }"
        :style="{ backgroundColor: bgColor }"
        :color="color"
        v-bind="$attrs"
        v-on="{ ...on, ...$listeners }"
      >
        {{ _icon }}
      </v-icon>
    </template>
    <span>{{ tooltipMessage }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'NajIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      required: false,
      default: '#000',
    },
    border: {
      type: Boolean,
      required: false,
      default: false,
    },
    rounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    tooltipMessage: {
      type: String,
      required: false,
    },
  },
  computed: {
    _icon() {
      if (!this.icon) return '';
      this.icon.replace('mdi-', '');
      return `mdi-${this.icon}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  padding: 5px;

  &.border {
    border: 2px solid #f0f1f7;
  }
  &.rounded {
    border-radius: 50% !important;
  }
}
</style>
